import moment from "moment";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

// TODO: TBD to remove
/**
 * Export data to XLS file
 * @param {Array<Object>} file
 * @param {string} fileName
 */
export const export_xls = (file, fileName = "Report") => {
  const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";
  const ws = XLSX.utils.json_to_sheet(file);
  const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
  const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const data = new Blob([excelBuffer], { type: fileType });
  FileSaver.saveAs(data, fileName + fileExtension);
};

/**
 * Download file from blob data
 * @param {Blob} blobData
 * @param {string} filename
 */
export const downloadFile = (blobData, filename) => {
  const url = window.URL.createObjectURL(new Blob([blobData]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

/**
 * @param {text} A string to convert to a slug.
 * @return {string} A slug version of the input string.
 */
export const toSlug = (text = "") =>
  text
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-") // replace ANY non-alphanumeric chunk with single -
    .replace(/^-+|-+$/g, ""); // remove leading/trailing hyphens

export const generateTimestamp = () => moment().format("YYYYMMDD-HHmmss");

/**
 * Builds a filename based on a given title and extension.
 *
 * @param {string} title The title of the file.
 * @param {string} [extension="pdf"] The extension of the file.
 * @return {string} The built filename.
 */
export const buildFileName = (title, extension = "pdf") => {
  const base = toSlug(title);
  const timestamp = generateTimestamp();
  return `${base}-${timestamp}.${extension}`;
};

/**
 * Derives a new list of columns from the given list, by filtering out columns
 * that do not have a field property equal to "actions", and mapping over the
 * remaining columns to create new columns with the same field and headerName, but
 * with flex set to 1 if it is not a number.
 *
 * @param {Array<Object>} columns The list of columns to derive from.
 * @return {Array<Object>} The derived list of columns.
 */
export const derivePdfColumns = (columns) =>
  columns
    .filter((col) => col.field && col.field !== "actions")
    .map(({ field, headerName, flex }) => ({
      field,
      headerName,
      flex: typeof flex === "number" ? flex : 1,
    }));

export const getPrintableRows = (rows) =>
  rows.map((row) =>
    Object.fromEntries(
      Object.entries(row).map(([key, value]) => [key, value === undefined || value === null ? "" : String(value)]),
    ),
  );
